import { ILogger, LOG_LEVEL } from './log.if';

const logMap: Record<LOG_LEVEL, (message: string) => void> = {
    [LOG_LEVEL.MILESTONE]: message => console.info(message),
    [LOG_LEVEL.TRACE]: message => console.debug(message),
    [LOG_LEVEL.VERBOSE]: message => console.debug(message),
    [LOG_LEVEL.INFO]: message => console.info(message),
    [LOG_LEVEL.WARN]: message => console.warn(message),
    [LOG_LEVEL.ERROR]: message => console.error(message),
    [LOG_LEVEL.FATAL]: message => console.error(message),
    [LOG_LEVEL.ASSERT]: message => console.assert(true, message),
};

function _consoleLog(logLevel: LOG_LEVEL, message: string) {
    logMap[logLevel](message);
}

function logger(levels: Array<LOG_LEVEL>): ILogger {
    const logger: ILogger = {
        assert: (condition, message) => condition && _consoleLog(LOG_LEVEL.ASSERT, message),
        log: (level, msg) => _consoleLog(level, msg),
    };

    return logger;
}

export default logger;
